export default function Go_Slices () {
  return (
    <div>
      <h1>Go_Slices </h1>
      <p>Slices</p>
    </div>
  );
}